// Static presentation constants. Filter option sources match Crewing / Perfect Truck Analytics (see wesFilterReference.ts).

export const WES_PALLET_STAGING_REPORT_LINK = '/navigator-reports/wes-pallet-staging-analytics';

export const WES_FALLBACK_TITLE = 'WES Pallet Staging Analytics';
export const WES_FALLBACK_DESCRIPTION = 'Pallet volume and staging rate by location, split into audit-related and other staging.';

export type WesTabKey = 'executive-overview' | 'location-detail';

export const WES_TABS: { key: WesTabKey; label: string }[] = [
  { key: 'executive-overview', label: 'Executive Overview' },
  { key: 'location-detail', label: 'Location Detail' },
];

// Same fixed 4-4-4-4 / 13-period fiscal constants Crewing and Perfect Truck use for options and quick selects.
export const WES_FIRST_ANALYTICS_YEAR = 2025;
export const WES_PERIODS_PER_YEAR = 13;
export const WES_WEEKS_PER_PERIOD = 4;
export const WES_QUARTER_START_PERIODS = [1, 4, 7, 10];

export type WesQuickSelectKey = 'lcw' | 'lcp' | 'wtd' | 'ptd' | 'qtd' | 'ytd';

export const WES_QUICK_SELECTS: { key: WesQuickSelectKey; label: string }[] = [
  { key: 'lcw', label: 'Last Closed Week' },
  { key: 'lcp', label: 'Last Closed Period' },
  { key: 'wtd', label: 'Week-to-Date' },
  { key: 'ptd', label: 'Period-to-Date' },
  { key: 'qtd', label: 'Quarter-to-Date' },
  { key: 'ytd', label: 'Year-to-Date' },
];
